var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-100"},[_c('router-view'),_vm._v(" "),_c('color-switcher',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }